const post_url: string = 'cron-prospect';

export const getLatestCronProspect = async (): Promise<any> => {
    const agencyId = UserProfile()?.agencyId;
    
    return await $fetch(`${post_url}/latest?agencyId=${agencyId}`, {
        method: 'GET',
        headers: FetchHeader(),
        baseURL: useRuntimeConfig().public.apiBaseUrl
    });
};

export const activateCronProspectPeriod = async (): Promise<any> => {
    const agencyId = UserProfile()?.agencyId;

    return await $fetch(`${post_url}/activate`, {
        method: 'POST',
        body: { agencyId },
        headers: FetchHeader(),
        baseURL: useRuntimeConfig().public.apiBaseUrl
    });
};